import { MarkerData } from "./types";

export function getData() {
  const data: MarkerData[] = [
    {
      id: "1",
      country: "United Arab Emirates",
      flag: "🇦🇪",
      city: "Dubái",
      year: 2018,
      position: { lat: 25.1972, lng: 55.2744 },
      zIndex: 0,
      type: "pin",
      url: "/city/dubai",
      description: "Clubs World Cup 2018",
    },
    {
      id: "2",
      country: "United Arab Emirates",
      flag: "🇦🇪",
      city: "Al Ain",
      year: 2018,
      position: { lat: 24.2053, lng: 55.7404 },
      zIndex: 0,
      type: "pin",
      url: "/city/al-ain",
      description: "Clubs World Cup 2018",
    },
    {
      id: "3",
      country: "United Arab Emirates",
      flag: "🇦🇪",
      city: "Abu Dhabi",
      year: 2018,
      position: { lat: 24.4765, lng: 54.3662 },
      zIndex: 0,
      type: "pin",
      url: "/city/abu-dhabi",
      description: "Clubs World Cup 2018",
    },
    {
      id: "4",
      country: "Spain",
      flag: "🇪🇸",
      city: "Barcelona",
      year: 2018,
      position: { lat: 41.3784, lng: 2.12 },
      zIndex: 0,
      type: "pin",
      url: "/city/barcelona",
    },
    {
      id: "5",
      country: "Spain",
      flag: "🇪🇸",
      city: "Madrid",
      year: 2018,
      position: { lat: 40.4531, lng: -3.6883 },
      zIndex: 0,
      type: "pin",
      url: "/city/madrid",
    },
    {
      id: "6",
      country: "France",
      flag: "🇫🇷",
      city: "Paris",
      year: 2018,
      position: { lat: 48.8584, lng: 2.2945 },
      zIndex: 0,
      type: "pin",
      url: "/city/paris",
    },
    {
      id: "7",
      country: "United States of America",
      flag: "🇺🇸",
      city: "Los Angeles",
      year: 2022,
      position: { lat: 33.8121, lng: -117.919 },
      zIndex: 0,
      type: "pin",
      url: "/city/los-angeles",
    },
    {
      id: "8",
      country: "United States of America",
      flag: "🇺🇸",
      city: "Orlando",
      year: 2022,
      position: { lat: 28.3852, lng: -81.5639 },
      zIndex: 0,
      type: "pin",
      url: "/city/orlando",
    },
    {
      id: "9",
      country: "France",
      flag: "🇫🇷",
      city: "Paris",
      year: 2022,
      position: { lat: 48.867, lng: 2.7833 },
      zIndex: 0,
      type: "pin",
      url: "/city/paris-2023",
    },
    {
      id: "10",
      country: "Spain",
      flag: "🇪🇸",
      city: "Barcelona",
      year: 2023,
      position: { lat: 41.4036, lng: 2.1744 },
      zIndex: 0,
      type: "pin",
      url: "/city/barcelona-2023",
    },
    {
      id: "11",
      country: "Spain",
      flag: "🇪🇸",
      city: "Madrid",
      year: 2023,
      position: { lat: 40.4169, lng: -3.6059 },
      zIndex: 0,
      type: "pin",
      url: "/city/madrid-2023",
    },
    {
      id: "12",
      country: "Italy",
      flag: "🇮🇹",
      city: "Venice",
      year: 2023,
      position: { lat: 45.4371, lng: 12.4534 },
      zIndex: 0,
      type: "pin",
      url: "/city/venice",
    },
    {
      id: "13",
      country: "Italy",
      flag: "🇮🇹",
      city: "Florence",
      year: 2023,
      position: { lat: 43.773145, lng: 11.2533853 },
      zIndex: 0,
      type: "pin",
      url: "/city/florence",
    },
    {
      id: "14",
      country: "Italy",
      flag: "🇮🇹",
      city: "Pisa",
      year: 2023,
      position: { lat: 43.7229, lng: 10.3966 },
      zIndex: 0,
      type: "pin",
      url: "/city/pisa",
    },
    {
      id: "15",
      country: "Italy",
      flag: "🇮🇹",
      city: "Milán",
      year: 2023,
      position: { lat: 45.4640975, lng: 9.1870556 },
      zIndex: 0,
      type: "pin",
      url: "/city/milan",
    },
    {
      id: "16",
      country: "Italy",
      flag: "🇮🇹",
      city: "Rome",
      year: 2023,
      position: { lat: 41.8902, lng: 12.4923 },
      zIndex: 0,
      type: "pin",
      url: "/city/rome",
    },
    {
      id: "17",
      country: "Vatican",
      flag: "🇻🇦",
      city: "Vatican",
      year: 2023,
      position: { lat: 41.9022, lng: 12.4539 },
      zIndex: 0,
      type: "pin",
      url: "/city/rome",
    },
    {
      id: "18",
      country: "Spain",
      flag: "🇪🇸",
      city: "Guadalajara",
      year: 2023,
      position: { lat: 40.6073, lng: -1.9469 },
      zIndex: 0,
      type: "pin",
      url: "/city/guadalajara",
    },
    {
      id: "19",
      country: "United States of America",
      flag: "🇺🇸",
      city: "Miami",
      year: 2024,
      position: { lat: 25.7617, lng: -80.1895 },
      zIndex: 0,
      type: "pin",
      url: "/city/miami",
    },
    {
      id: "20",
      country: "Bahamas",
      flag: "🇧🇸",
      city: "Nassau",
      year: 2024,
      position: { lat: 25.0582, lng: -77.3431 },
      zIndex: 0,
      type: "pin",
      url: "/city/nassau",
      images: [
        "/images/places/nassau-1.webp",
        "/images/places/nassau-2.webp",
        "/images/places/nassau-3.webp",
        "/images/places/nassau-4.webp",
        "/images/places/nassau-5.webp",
      ],
    },
    {
      id: "21",
      country: "Dominican Republic",
      flag: "🇩🇴",
      city: "Puerto Plata",
      year: 2024,
      position: { lat: 19.79, lng: -70.6968 },
      zIndex: 0,
      type: "pin",
      url: "/city/puerto-plata",
      images: [
        "/images/places/puerto-plata-1.webp",
        "/images/places/puerto-plata-2.webp",
        "/images/places/puerto-plata-3.webp",
        "/images/places/puerto-plata-4.webp",
        "/images/places/puerto-plata-5.webp",
      ],
    },
    {
      id: "22",
      country: "United States of America",
      flag: "🇺🇸",
      city: "San Diego",
      year: 2024,
      position: { lat: 32.7157, lng: -117.1611 },
      zIndex: 0,
      type: "html",
      url: "/city/san-diego",
    },
    {
      id: "23",
      country: "Belgium",
      flag: "🇧🇪",
      city: "Brussels",
      year: 2024,
      position: { lat: 50.8467, lng: 4.3525 },
      zIndex: 0,
      type: "html",
      url: "/city/brussels",
    },
    {
      id: "24",
      country: "Netherlands",
      flag: "🇳🇱",
      city: "Amsterdam",
      year: 2024,
      position: { lat: 52.3728, lng: 4.9 },
      zIndex: 0,
      type: "html",
      url: "/city/amsterdam",
    },
    {
      id: "25",
      country: "England",
      flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
      city: "London",
      year: 2024,
      position: { lat: 51.5007, lng: -0.1246 },
      zIndex: 0,
      type: "html",
      url: "/city/london",
    },
    {
      id: "26",
      country: "France",
      flag: "🇫🇷",
      city: "Paris",
      year: 2024,
      position: { lat: 48.8867, lng: 2.3431 },
      zIndex: 0,
      type: "html",
      url: "/city/paris-2024",
    },
    {
      id: "27",
      country: "Belgium",
      flag: "🇧🇪",
      city: "Bruges",
      year: 2025,
      position: { lat: 51.2089, lng: 3.2242 },
      zIndex: 0,
      type: "html",
      url: "/city/bruges",
    },
    {
      id: "28",
      country: "Belgium",
      flag: "🇧🇪",
      city: "Antwerp",
      year: 2025,
      position: { lat: 51.2194, lng: 4.4025 },
      zIndex: 0,
      type: "html",
      url: "/city/antwerp",
    },
    {
      id: "29",
      country: "Belgium",
      flag: "🇧🇪",
      city: "Ghent",
      year: 2025,
      position: { lat: 51.0543, lng: 3.7174 },
      zIndex: 0,
      type: "html",
      url: "/city/ghent",
    },
    {
      id: "30",
      country: "Netherlands",
      flag: "🇳🇱",
      city: "Zaanse Schans",
      year: 2024,
      position: { lat: 52.4731, lng: 4.8163 },
      zIndex: 0,
      type: "html",
      url: "/city/zaanse-schans",
    },
    {
      id: "31",
      country: "Netherlands",
      flag: "🇳🇱",
      city: "Zaandam",
      year: 2024,
      position: { lat: 52.4383, lng: 4.826 },
      zIndex: 0,
      type: "html",
      url: "/city/zaandam",
    },
    {
      id: "32",
      country: "Italy",
      flag: "🇮🇹",
      city: "Rome",
      year: 2025,
      position: { lat: 41.8902, lng: 12.4923 },
      zIndex: 0,
      type: "html",
      url: "/city/rome",
    },
    {
      id: "33",
      country: "Italy",
      flag: "🇮🇹",
      city: "Venice",
      year: 2025,
      position: { lat: 45.4371, lng: 12.4534 },
      zIndex: 0,
      type: "html",
      url: "/city/venice",
    },
    {
      id: "34",
      country: "Italy",
      flag: "🇮🇹",
      city: "Padua",
      year: 2025,
      position: { lat: 45.4076, lng: 11.8767 },
      zIndex: 0,
      type: "html",
      url: "/city/padua",
    },
    {
      id: "35",
      country: "Italy",
      flag: "🇮🇹",
      city: "Florence",
      year: 2025,
      position: { lat: 43.7746, lng: 11.256 },
      zIndex: 0,
      type: "html",
      url: "/city/florence",
    },
    {
      id: "36",
      country: "Italy",
      flag: "🇮🇹",
      city: "Pisa",
      year: 2025,
      position: { lat: 43.7228, lng: 10.3966 },
      zIndex: 0,
      type: "html",
      url: "/city/pisa",
    },
    {
      id: "37",
      country: "Portugal",
      flag: "🇵🇹",
      city: "Lisbon",
      year: 2025,
      position: { lat: 38.7169, lng: -9.1399 },
      zIndex: 0,
      type: "html",
      url: "/city/lisbon",
    },
    {
      id: "38",
      country: "Portugal",
      flag: "🇵🇹",
      city: "Oporto",
      year: 2025,
      position: { lat: 41.1496, lng: -8.6109 },
      zIndex: 0,
      type: "html",
      url: "/city/oporto",
    },
    {
      id: "39",
      country: "Spain",
      flag: "🇪🇸",
      city: "Madrid",
      year: 2025,
      position: { lat: 40.4154, lng: -3.6844 },
      zIndex: 0,
      type: "html",
      url: "/city/madrid",
    },
    {
      id: "40",
      country: "Vatican",
      flag: "🇻🇦",
      city: "Vatican",
      year: 2025,
      position: { lat: 41.9022, lng: 12.4539 },
      zIndex: 0,
      type: "pin",
      url: "/city/rome",
    },
    {
      id: "41",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Zapopan",
      year: 2025,
      position: { lat: 20.6817764, lng: -103.4652204 },
      zIndex: 0,
      type: "pin",
      url: "/city/guadalajara",
    },
    {
      id: "42",
      country: "Mexico",
      flag: "🇲🇽",
      city: "CDMX",
      year: 2024,
      position: { lat: 19.4270205, lng: -99.1724703 },
      zIndex: 0,
      type: "pin",
      url: "/city/cdmx",
    },
    {
      id: "43",
      country: "Mexico",
      flag: "🇲🇽",
      city: "La Paz",
      year: 2022,
      position: { lat: 24.1528176, lng: -110.3499993 },
      zIndex: 0,
      type: "pin",
      url: "/city/cdmx",
    },

    {
      id: "45",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Mazatlán",
      year: 2023,
      position: { lat: 23.2768991, lng: -106.3850388 },
      zIndex: 0,
      type: "pin",
      url: "/city/cdmx",
    },
    {
      id: "46",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Pachuca",
      year: 2024,
      position: { lat: 20.1051452, lng: -98.7609245 },
      zIndex: 0,
      type: "pin",
      url: "/city/cdmx",
    },
    {
      id: "47",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Morelia",
      year: 2018,
      position: { lat: 19.7187738, lng: -101.2359693 },
      zIndex: 0,
      type: "pin",
      url: "/city/cdmx",
    },
    {
      id: "48",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Guanajuato",
      year: 2009,
      position: { lat: 21.0250773, lng: -101.2785014 },
      zIndex: 0,
      type: "pin",
      url: "/city/cdmx",
    },
    {
      id: "49",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Monterrey",
      year: 2009,
      position: { lat: 25.6691181, lng: -100.2470751 },
      zIndex: 0,
      type: "pin",
      url: "/city/cdmx",
    },
    {
      id: "50",
      country: "Mexico",
      flag: "🇲🇽",
      city: "León",
      year: 2009,
      position: { lat: 21.1155454, lng: -101.6602778 },
      zIndex: 0,
      type: "pin",
      url: "/city/cdmx",
    },
    {
      id: "51",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Los Cabos",
      year: 2003,
      position: { lat: 22.9336877, lng: -109.9714127 },
      zIndex: 0,
      type: "pin",
      url: "/city/cdmx",
    },

    {
      id: "52",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Veracruz",
      year: 2025,
      position: { lat: 19.164222, lng: -96.125017 },
      zIndex: 0,
      type: "pin",
      url: "/city/veracruz",
      description: "Kings League finals 2025",
    },
    {
      id: "53",
      country: "United States of America",
      flag: "🇺🇸",
      city: "Los Angeles",
      year: 2025,
      position: { lat: 33.953587, lng: -118.33963 },
      zIndex: 0,
      type: "pin",
      url: "/city/los-angeles-2025",
      description: "Copa Oro 2025",
    },
    {
      id: "54",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Torreón",
      year: 2025,
      position: { lat: 25.62891, lng: -103.37995 },
      zIndex: 0,
      type: "pin",
      url: "/city/torreon-2025",
      description: "Santos vs Chivas",
    },
    {
      id: "55",
      country: "Mexico",
      flag: "🇲🇽",
      city: "La Paz",
      year: 2025,
      position: { lat: 24.15685, lng: -110.3033 },
      zIndex: 0,
      type: "pin",
      url: "/city/la-paz-2025",
    },
    {
      id: "56",
      country: "France",
      flag: "🇫🇷",
      city: "Paris",
      year: 2025,
      position: { lat: 49.00972, lng: 2.54778 },
      zIndex: 0,
      type: "pin",
      url: "/city/paris-2025",
    },
    {
      id: "57",
      country: "Czech Republic",
      flag: "🇨🇿",
      city: "Prague",
      year: 2025,
      position: { lat: 50.0855, lng: 14.4192 },
      zIndex: 0,
      type: "pin",
      url: "/city/prague-2025",
    },
    {
      id: "58",
      country: "Austria",
      flag: "🇦🇹",
      city: "Wien",
      year: 2025,
      position: { lat: 48.2085, lng: 16.373 },
      zIndex: 0,
      type: "pin",
      url: "/city/wien-2025",
    },
    {
      id: "59",
      country: "Hungary",
      flag: "🇭🇺",
      city: "Budapest",
      year: 2025,
      position: { lat: 47.50312, lng: 19.095879 },
      zIndex: 0,
      type: "pin",
      url: "/city/budapest-2025",
    },
    {
      id: "60",
      country: "Germany",
      flag: "🇩🇪",
      city: "Berlin",
      year: 2025,
      position: { lat: 52.513943, lng: 13.378155 },
      zIndex: 0,
      type: "pin",
      url: "/city/berlin-2025",
    },
    {
      id: "61",
      country: "Germany",
      flag: "🇩🇪",
      city: "Oranienburg",
      year: 2025,
      position: { lat: 52.76583, lng: 13.26417 },
      zIndex: 0,
      type: "pin",
      url: "/city/oranienburg-2025",
    },
    {
      id: "62",
      country: "Germany",
      flag: "🇩🇪",
      city: "Munchen",
      year: 2025,
      position: { lat: 48.2188, lng: 11.6247 },
      zIndex: 0,
      type: "pin",
      url: "/city/munchen-2025",
    },
    {
      id: "63",
      country: "Spain",
      flag: "🇪🇸",
      city: "Madrid",
      year: 2026,
      position: { lat: 40.41693, lng: -3.70695 },
      zIndex: 0,
      type: "pin",
      url: "/city/madrid-2026",
    },
    {
      id: "64",
      country: "Spain",
      flag: "🇪🇸",
      city: "Malaga",
      year: 2026,
      position: { lat: 36.7341, lng: -4.4264 },
      zIndex: 0,
      type: "pin",
      url: "/city/malaga-2026",
    },
    {
      id: "65",
      country: "Spain",
      flag: "🇪🇸",
      city: "Granada",
      year: 2026,
      position: { lat: 37.1526, lng: -3.5952 },
      zIndex: 0,
      type: "pin",
      url: "/city/granada-2026",
    },
    {
      id: "66",
      country: "Spain",
      flag: "🇪🇸",
      city: "Barcelona",
      year: 2026,
      position: { lat: 41.3649, lng: 2.1557 },
      zIndex: 0,
      type: "pin",
      url: "/city/barcelona-2026",
    },
    {
      id: "67",
      country: "Spain",
      flag: "🇪🇸",
      city: "Valencia",
      year: 2026,
      position: { lat: 39.4747, lng: -0.3585 },
      zIndex: 0,
      type: "pin",
      url: "/city/valencia-2026",
    },
    {
      id: "68",
      country: "Spain",
      flag: "🇪🇸",
      city: "Villareal",
      year: 2026,
      position: { lat: 39.9443, lng: -0.1035 },
      zIndex: 0,
      type: "pin",
      url: "/city/villareal-2026",
    },
    {
      id: "69",
      country: "Spain",
      flag: "🇪🇸",
      city: "Bilbao",
      year: 2026,
      position: { lat: 43.2643, lng: -2.9498 },
      zIndex: 0,
      type: "pin",
      url: "/city/bilbao-2026",
    },
    {
      id: "70",
      country: "Spain",
      flag: "🇪🇸",
      city: "San Sebastian",
      year: 2026,
      position: { lat: 43.3014, lng: -1.9737 },
      zIndex: 0,
      type: "pin",
      url: "/city/san-sebastian-2026",
    },
    {
      id: "71",
      country: "Spain",
      flag: "🇪🇸",
      city: "Sevilla",
      year: 2026,
      position: { lat: 37.417, lng: -6.006 },
      zIndex: 0,
      type: "pin",
      url: "/city/sevilla-2026",
    },
    {
      id: "72",
      country: "United States of America",
      flag: "🇺🇸",
      city: "Las Vegas",
      year: 2026,
      position: { lat: 36.1219, lng: -115.1696 },
      zIndex: 0,
      type: "pin",
      url: "/city/las-vegas-2026",
    },
    {
      id: "73",
      country: "United States of America",
      flag: "🇺🇸",
      city: "Grand Canyon",
      year: 2026,
      position: { lat: 36.1069, lng: -112.1129 },
      zIndex: 0,
      type: "pin",
      url: "/city/grand-canyon-2026",
    },
    {
      id: "74",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Puebla",
      year: 2026,
      position: { lat: 19.078056, lng: -98.164444 },
      zIndex: 0,
      type: "pin",
      url: "/city/puebla-2026",
      description: "Spain vs Peru",
    },
    {
      id: "75",
      country: "Mexico",
      flag: "🇲🇽",
      city: "Puebla",
      year: 2026,
      position: { lat: 19.0423, lng: -98.1981 },
      zIndex: 0,
      type: "pin",
      url: "/city/puebla-chivas-2026",
      description: "Puebla vs Chivas",
    },
    {
      id: "76",
      country: "United States of America",
      flag: "🇺🇸",
      city: "Orlando",
      year: 2026,
      position: { lat: 28.4405, lng: -81.4476 },
      zIndex: 0,
      type: "pin",
      url: "/city/orlando-2026",
    },
  ];

  return data;
}
